// extracted by mini-css-extract-plugin
export default {"STVideoAuthor":"style_STVideoAuthor__bm2TD","periodBox":"style_periodBox__rcAVX","speedBox":"style_speedBox__dN44V"};